import posthog from 'posthog-js';

let analyticsEnabled = false;

export function initAnalytics() {
  const consent = localStorage.getItem('analytics-consent');
  if (consent !== 'true') return;

  if (import.meta.env.VITE_POSTHOG_KEY) {
    posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',
      person_profiles: 'identified_only',
      capture_pageview: false,
    });
    analyticsEnabled = true;
  }

  // Google Analytics
  // Ensure window.dataLayer is recognized by TypeScript
  if (import.meta.env.VITE_GA_MEASUREMENT_ID) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${import.meta.env.VITE_GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: unknown[]) {
      window.dataLayer.push(args);
    }
    gtag('js', new Date());
    gtag('config', import.meta.env.VITE_GA_MEASUREMENT_ID, {
      anonymize_ip: true,
      cookie_flags: 'SameSite=None;Secure',
    });
  }
}

export function trackEvent(event: string, properties?: Record<string, unknown>) {
  if (!analyticsEnabled) return;
  posthog.capture(event, properties);
}

export function trackPageView(path: string) {
  if (!analyticsEnabled) return;
  posthog.capture('$pageview', { $current_url: path });
}

export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  if (!analyticsEnabled) return;
  posthog.identify(userId, traits);
}

export function setConsent(granted: boolean) {
  localStorage.setItem('analytics-consent', granted.toString());
  if (granted) {
    initAnalytics();
  }
  else {
    posthog.opt_out_capturing();
  }
}

